import {Action} from '@ngrx/store';
import {Post} from '../post.model';

export const ADD_AUDIT = 'ADD_POST_AUDIT';
export const GET_AUDITS = 'GET_POST_AUDITS';
export const GET_AUDIT = 'GET_POST_AUDIT';
export const SET_AUDITS = 'SET_POST_AUDITS';
export const SET_AUDIT = 'SET_POST_AUDIT';
export const SET_LOADER = 'SET_POST_LOADER';
export const GET_FOLLOWER_STAT = 'GET_POST_FOLLOWER_STAT';
export const GET_MEDIA_STAT = 'GET_POST_MEDIA_STAT';
export const GET_AUDIENCE_STAT = 'GET_POST_AUDIENCE_STAT';
export const GET_AUDIENCE_LOCATION = 'GET_POST_AUDIENCE_LOCATION';
export const GET_POST_DETAIL = 'GET_POST_DETAIL';
export const SET_POST_DETAIL = 'SET_POST_DETAIL';
export const GET_POST_PROGRESS = 'GET_POST_PROGRESS';
export const GET_PROFILE_MEDIA = 'GET_POST_PROFILE_MEDIA';
export const GET_EXPORT_POST = 'GET_EXPORT_POST';


export class AddAudit implements Action {
  readonly type = ADD_AUDIT;

  constructor(public payload: string) {}
}

export class GetAudits implements Action {
  readonly type = GET_AUDITS;
}

export class GetAudit implements Action {
  readonly type = GET_AUDIT;

  constructor(public payload: number) {}
}

export class SetAudits implements Action {
  readonly type = SET_AUDITS;

  constructor(public payload: Post[]) {}
}

export class SetAudit implements Action {
  readonly type = SET_AUDIT;

  constructor(public payload: Post) {}
}

export class GetFollowerStat implements Action {
  readonly type = GET_FOLLOWER_STAT;

  constructor(public payload: {id: number, type: number}) {}
}

export class GetMediaStat implements Action {
  readonly type = GET_MEDIA_STAT;

  constructor(public payload: {id: number}) {}
}

export class GetAudienceStat implements Action {
  readonly type = GET_AUDIENCE_STAT;

  constructor(public payload: {id: number, type: number}) {}
}

export class GetAudienceLocation implements Action {
  readonly type = GET_AUDIENCE_LOCATION;

  constructor(public payload: {id: number, type: number}) {}
}

export class SetLoader implements Action {
  readonly type = SET_LOADER;

  constructor(public payload: {module: string, box: string, value: boolean}) {}
}

export class GetPostDetail implements Action {
  readonly type = GET_POST_DETAIL;

  constructor(public payload: {id: number}) {}
}

export class SetPostDetail implements Action {
  readonly type = SET_POST_DETAIL;

  constructor(public payload: any) {
  }
}

export class GetPostProgress implements Action {
  readonly type = GET_POST_PROGRESS;

  constructor(public payload: {id: number}) {}
}

export class GetProfileMedia implements Action {
  readonly type = GET_PROFILE_MEDIA;

  constructor(public payload: {id: number}) {}
}

export class GetExportPost implements Action {
  readonly type = GET_EXPORT_POST;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export type PostActions = AddAudit | GetAudits | GetAudit | SetAudit | SetAudits | SetLoader
  | GetFollowerStat | GetMediaStat | GetAudienceStat | GetAudienceLocation | GetPostDetail | SetPostDetail
  | GetPostProgress | GetProfileMedia | GetExportPost;
  ;
